module.exports = __webpack_public_path__ + "static/media/chat-bg.608ab5fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/chat-bg.png
// module id = 1929
// module chunks = 1